<script setup>
  import ComponentIcon from "@components/Icons/Icon.vue";

  defineOptions({
    name: "ComponentEmptyState",
  });
</script>

<template>
  <div
    class="mx-auto flex w-full max-w-96 items-start space-x-2"
    :class="{'mt-4': !$attrs.class || !$attrs.class.includes('mt-')}"
    :data-test="getTestId('empty-state')"
  >
    <ComponentIcon class="text-2xl text-blue-600">info</ComponentIcon>

    <div class="text-blue-900">
      <slot />
    </div>
  </div>
</template>
